import React from 'react';
import { HomePage } from '../../components/homapage';

const HomeContainer = () => {
    return <HomePage />;
};

export default HomeContainer;
